// Two-part time picker: pick the hour, then the minute (in 5-minute blocks).
// Stores/emits HH:MM strings, or "" when neither part is set.

const HOURS = Array.from({ length: 24 }, (_, i) => String(i).padStart(2, "0"));
const MINUTES = Array.from({ length: 12 }, (_, i) => String(i * 5).padStart(2, "0"));

function splitTime(value) {
  if (!value || !value.includes(":")) return ["", ""];
  const [h, m] = value.split(":");
  return [h ?? "", m ?? ""];
}

export default function TimePicker({ value, onChange, testid, className = "" }) {
  const [hour, minute] = splitTime(value);

  const emit = (h, m) => {
    if (!h && !m) return onChange("");
    // If only one part is chosen, default the other to 00 so it's a valid HH:MM.
    const hh = (h || "00").padStart(2, "0");
    const mm = (m || "00").padStart(2, "0");
    onChange(`${hh}:${mm}`);
  };

  // Surface a non-5-min legacy minute as a one-off option so existing data isn't lost.
  const showLegacyMinute = minute && !MINUTES.includes(minute);

  const partCls = `${className} flex-1 min-w-0`;

  return (
    <div className="flex items-center gap-2" data-testid={testid}>
      <select
        data-testid={testid ? `${testid}-hour` : undefined}
        aria-label="Hour"
        className={partCls}
        value={hour}
        onChange={(e) => emit(e.target.value, minute)}
      >
        <option value="">HH</option>
        {HOURS.map((h) => (
          <option key={h} value={h}>{h}</option>
        ))}
      </select>
      <span className="text-[#7A7A7A] text-lg select-none">:</span>
      <select
        data-testid={testid ? `${testid}-minute` : undefined}
        aria-label="Minute"
        className={partCls}
        value={minute}
        onChange={(e) => emit(hour, e.target.value)}
      >
        <option value="">MM</option>
        {showLegacyMinute && <option value={minute}>{minute}</option>}
        {MINUTES.map((m) => (
          <option key={m} value={m}>{m}</option>
        ))}
      </select>
    </div>
  );
}
